import { formatRelativeTime } from '../../../core/utils/hangoutUtils.js';
import { buildSmallSpriteUrl, getDefaultStandingActionId } from '../../../js/utils/spriteFallbacks.js';
import { getLastRoundSpriteTuple, lastRoundToActiveCharacters } from './state-utils.js';

const getConversationCharacters = (conversation) => {
  if (Array.isArray(conversation?.allCharacters) && conversation.allCharacters.length > 0) {
    return conversation.allCharacters;
  }
  return lastRoundToActiveCharacters(conversation?.lastRound);
};

const findListedCharacter = (characters, characterId) => {
  if (!Array.isArray(characters) || characterId == null || characterId === '') return null;
  return characters.find((entry) => String(entry?.id) === String(characterId)) || null;
};

const appendScenarioTitle = (card, fullScenarioName) => {
  const scenarioTitle = document.createElement('h4');
  scenarioTitle.className = 'conversation-scenario-title';
  scenarioTitle.textContent = fullScenarioName;
  scenarioTitle.setAttribute('data-full-name', fullScenarioName);
  scenarioTitle.setAttribute('title', fullScenarioName);
  card.appendChild(scenarioTitle);
};

const appendConversationMeta = (card, conversation) => {
  const metaInfo = document.createElement('div');
  metaInfo.className = 'conversation-meta';

  const messageCount = document.createElement('span');
  messageCount.className = 'conversation-message-count';
  messageCount.textContent = `${conversation.messageCount || 0} msgs`;

  const timestamp = document.createElement('span');
  timestamp.className = 'conversation-timestamp';
  const date = new Date(conversation.lastUpdated || conversation.createdAt);
  timestamp.textContent = formatRelativeTime(date) || '';

  metaInfo.appendChild(messageCount);
  metaInfo.appendChild(timestamp);
  card.appendChild(metaInfo);
};

const appendSprites = (card, conversation, listedCharacters) => {
  const characters = getConversationCharacters(conversation);
  const sprites = document.createElement('div');
  sprites.className = 'recent-chat-sprites';

  for (const [index, char] of characters.entries()) {
    const characterId = char?.id ?? char?.characterId;
    if (characterId == null || characterId === '') continue;

    const tuple = getLastRoundSpriteTuple(conversation, characterId);
    let actionId = tuple.actionId;
    if (actionId === null || actionId === undefined || actionId === '') {
      const listed = findListedCharacter(listedCharacters, characterId);
      actionId = getDefaultStandingActionId(char.gender ?? listed?.gender);
    }

    const img = document.createElement('img');
    img.className = `recent-chat-sprite recent-chat-sprite-${index}`;
    img.alt = char.name || `Character ${characterId}`;
    img.draggable = false;
    img.src = buildSmallSpriteUrl(
      characterId,
      actionId,
      String(tuple.outfitId || char.outfitId || 0)
    );
    sprites.appendChild(img);
  }

  if (sprites.childElementCount > 0) {
    card.setAttribute('data-sprite-count', String(sprites.childElementCount));
    card.appendChild(sprites);
  }
};

export const buildRecentChatCard = (conversation, {
  backgroundImage,
  onCardClick,
  listedCharacters
}) => {
  const fullScenarioName = (conversation?.scenarioName || 'Unknown Scenario').trim() || 'Unknown Scenario';
  const card = document.createElement('button');
  card.type = 'button';
  card.className = 'recent-chat-card';
  card.setAttribute('data-conversation-id', conversation.conversationId);
  card.setAttribute('aria-label', `Continue conversation: ${fullScenarioName}`);
  card.style.backgroundImage = `url('${backgroundImage}')`;

  const overlay = document.createElement('div');
  overlay.className = 'conversation-overlay';
  card.appendChild(overlay);

  appendScenarioTitle(card, fullScenarioName);
  appendSprites(card, conversation, listedCharacters);
  appendConversationMeta(card, conversation);

  if (onCardClick) {
    card.addEventListener('click', (event) => {
      event.preventDefault();
      onCardClick(conversation, card);
    });
  }

  return card;
};
